import React from 'react';
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Button,
  Text,
  Flex,
  Box,
  useColorModeValue,
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

const FlagID = () => (
  <svg
    width="20"
    height="14"
    viewBox="0 0 20 14"
    style={{ borderRadius: '2px', border: '1px solid rgba(0,0,0,0.15)', display: 'block' }}
  >
    <rect width="20" height="7" fill="#E70011" />
    <rect y="7" width="20" height="7" fill="#FFFFFF" />
  </svg>
);

const FlagEN = () => (
  <svg
    width="20"
    height="14"
    viewBox="0 0 60 42"
    style={{ borderRadius: '2px', border: '1px solid rgba(0,0,0,0.15)', display: 'block' }}
  >
    <rect width="60" height="42" fill="#012169" />
    <path d="M0 0L60 42M60 0L0 42" stroke="#ffffff" strokeWidth="8" />
    <path d="M0 0L60 42M60 0L0 42" stroke="#C8102E" strokeWidth="4" />
    <path d="M30 0V42M0 21H60" stroke="#ffffff" strokeWidth="12" />
    <path d="M30 0V42M0 21H60" stroke="#C8102E" strokeWidth="8" />
  </svg>
);

const languages = [
  { code: 'id', short: 'ID', flag: <FlagID />, label: 'Indonesia' },
  { code: 'en', short: 'EN', flag: <FlagEN />, label: 'English' },
];

export default function LanguageSwitcher({ showLabel = false, ...rest }) {
  const { i18n } = useTranslation();
  const menuBg = useColorModeValue('white', 'navy.800');
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const hoverBg = useColorModeValue('gray.100', 'whiteAlpha.100');
  const activeBg = useColorModeValue('brand.50', 'whiteAlpha.200');
  const shadow = useColorModeValue(
    '14px 17px 40px 4px rgba(112, 144, 176, 0.18)',
    '14px 17px 40px 4px rgba(112, 144, 176, 0.06)',
  );

  const currentLang = languages.find((l) => l.code === i18n.language) || languages[0];

  const changeLanguage = (code) => {
    i18n.changeLanguage(code);
    localStorage.setItem('orthcvms-lang', code);
  };

  return (
    <Menu>
      <MenuButton
        as={Button}
        variant="ghost"
        size="sm"
        px="8px"
        fontSize="sm"
        minW="unset"
        h="34px"
        {...rest}
      >
        <Flex align="center" gap="6px">
          <Box flexShrink={0}>{currentLang.flag}</Box>
          <Text fontSize="xs" fontWeight="700" color={textColor}>
            {showLabel ? `${currentLang.label} (${currentLang.short})` : currentLang.short}
          </Text>
        </Flex>
      </MenuButton>
      <MenuList
        boxShadow={shadow}
        bg={menuBg}
        borderRadius="12px"
        minW="160px"
        p="8px"
        zIndex="1000"
      >
        {languages.map((lang) => (
          <MenuItem
            key={lang.code}
            onClick={() => changeLanguage(lang.code)}
            borderRadius="8px"
            bg={i18n.language === lang.code ? activeBg : 'transparent'}
            _hover={{ bg: hoverBg }}
            mb="4px"
          >
            <Flex align="center" gap="10px" w="100%">
              <Box flexShrink={0}>{lang.flag}</Box>
              <Text
                fontSize="sm"
                fontWeight={i18n.language === lang.code ? '700' : '500'}
                color={textColor}
              >
                {lang.label} ({lang.short})
              </Text>
            </Flex>
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
}

